"use client";

import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { backgroundVariants, classNames, TextBody, UnstyledButton } from "@opensea/ui-kit";
import { AccountCircle, AutoAwesomeMosaic, Explore, ExploreFilled, Image, Toll } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { ExpandedSearchMenuPart } from "./ExpandedSearchMenuPart";
function useFilterCategories() {
  const $ = _c(26);
  const t = useTranslations("ExpandedSearchMenuResults.filters");
  let t0;
  if ($[0] !== t) {
    t0 = t("all");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      key: "all",
      label: t0,
      icon: Explore,
      activeIcon: ExploreFilled
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("collections");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      key: "collections",
      label: t2,
      icon: AutoAwesomeMosaic,
      activeIcon: AutoAwesomeMosaic
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("tokens");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      key: "tokens",
      label: t4,
      icon: Toll,
      activeIcon: Toll
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("items");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = {
      key: "items",
      label: t6,
      icon: Image,
      activeIcon: Image
    };
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("wallets");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = {
      key: "wallets",
      label: t8,
      icon: AccountCircle,
      activeIcon: AccountCircle
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t3 || $[22] !== t5 || $[23] !== t7 || $[24] !== t9) {
    t10 = [t1, t3, t5, t7, t9];
    $[20] = t1;
    $[21] = t3;
    $[22] = t5;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const categories = t10;
  return categories;
}
export function ExpandedSearchSidebar(t0) {
  const $ = _c(9);
  const {
    selectedCategory,
    onCategoryChangeAction
  } = t0;
  const categories = useFilterCategories();
  let t1;
  if ($[0] !== categories || $[1] !== onCategoryChangeAction || $[2] !== selectedCategory) {
    let t2;
    if ($[4] !== onCategoryChangeAction || $[5] !== selectedCategory) {
      t2 = category => {
        const isSelected = selectedCategory === category.key;
        const Icon = isSelected ? category.activeIcon : category.icon;
        return <UnstyledButton className={classNames("flex items-center gap-2 rounded-md px-3 py-2 text-left text-base transition-colors duration-150 ease-out", isSelected ? backgroundVariants({
          background: "additional-2"
        }) : "hover:bg-bg-additional-2")} key={category.key} onClick={() => {
          track("Search Category Selected", {
            category: category.key,
            previous_category: selectedCategory
          });
          onCategoryChangeAction(category.key);
        }}><Icon fill={isSelected ? "text-primary" : "text-secondary"} size={20} /><TextBody color={isSelected ? "text-primary" : "text-secondary"} size="sm" weight="semibold">{category.label}</TextBody></UnstyledButton>;
      };
      $[4] = onCategoryChangeAction;
      $[5] = selectedCategory;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = categories.map(t2);
    $[0] = categories;
    $[1] = onCategoryChangeAction;
    $[2] = selectedCategory;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ExpandedSearchMenuPart className="w-full shrink-0 flex-row gap-2 overflow-x-auto border-border-1 border-b bg-bg-primary p-3 lg:w-48 lg:flex-col lg:overflow-x-visible lg:border-r lg:border-b-0">{t1}</ExpandedSearchMenuPart>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}